import dayjs from 'dayjs';
import { PersonHoverCard } from './PersonHoverCard';

type Props = {
  audit: AuditInfoViewModel;
}

export type AuditInfoViewModel = {
  ModifiedByUserID: number;
  ModifiedByUserName: string;
  ModifiedByDateTime: string;
  CreatedByUserID: number;
  CreatedByUserName: string;
  CreatedByDateTime: string;
  RetiredByUserID: number | null;
  RetiredByUserName: string | null;
  RetiredByDateTime: string | null;
}

const AuditInfo = (props: Props) => {
  const audit = props.audit;
  return <>
    <h2>Audit</h2>
    <div className="form-group row">
      <label className="col-sm-4 text-right col-form-label">Created</label>
      <div className="col-sm-8">
        <p className="form-control-plaintext">
          <PersonHoverCard userId={audit.CreatedByUserID}><span style={{ borderBottom: "1px dotted" }}>{audit.CreatedByUserName}</span></PersonHoverCard> - {dayjs.utc(audit.CreatedByDateTime).tz("America/New_York").format('MM/DD/YYYY HH:mm:ss')}
        </p>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-sm-4 text-right col-form-label">Updated</label>
      <div className="col-sm-8">
        <p className="form-control-plaintext">
          <PersonHoverCard userId={audit.ModifiedByUserID}><span style={{ borderBottom: "1px dotted" }}>{audit.ModifiedByUserName}</span></PersonHoverCard> - {dayjs.utc(audit.ModifiedByDateTime).tz("America/New_York").format('MM/DD/YYYY HH:mm:ss')}
        </p>
      </div>
    </div>
    {audit.RetiredByUserID && <div className="form-group row">
      <label className="col-sm-4 text-right col-form-label">Retired</label>
      <div className="col-sm-8">
        <p className="form-control-plaintext">
          <PersonHoverCard userId={audit.RetiredByUserID}><span style={{ borderBottom: "1px dotted" }}>{audit.RetiredByUserName}</span></PersonHoverCard> - {dayjs.utc(audit.RetiredByDateTime).tz("America/New_York").format('MM/DD/YYYY HH:mm:ss')}
        </p>
      </div>
    </div>}
  </>
}
export default AuditInfo;
